import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { Content, Main } from "../../components/Layout";
import { Row, Col } from "react-bootstrap";
import Slct from "../../components/Slct";
import Loading from "../../components/Loading";
import Pagenation from "../../components/Pagenation";
import useWrapper from "../../hooks/useWrapper";
import { InputText } from "../../components/Input";
import useFormat from "../../hooks/utils/useFormat";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import TableResponsive from "../../components/TableResponsive";
import Accordion2 from "../../components/Accordion";
import ButtonLink from "../../components/Button/ButtonLink";

export default function Institutions() {
  const { setbreadcrumb, config, permissions } = useWrapper();
  const { formatQuery } = useFormat();

  const [isWaitingResponse, setisWaitingResponse] = useState(true);
  const [isLoadingEssential, setisLoadingEssential] = useState(true);
  const [isLoadingInstitutions, setisLoadingInstitutions] = useState(false);
  const [isLoadingCities, setisLoadingCities] = useState(false);
  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingInstitutions);
  }, [isLoadingEssential, isLoadingInstitutions]);

  const [institutions, setinstitutions] = useState([]);
  const filter_init = {};
  const [filter, setfilter] = useState(filter_init);
  const applyFilter = async (__filter, __setPreset) => {
    document.querySelector("#page-filter .accordion-button[aria-expanded='true']")?.click();
    try {
      setisLoadingInstitutions(true);
      const _filter = __filter || filter;
      if (!!__filter) setfilter(__filter);
      const { ...query } = _filter;
      const _query = `?joins=states,city&paginate=true&${formatQuery(query)}`;
      const { data: _institutions } = await api.get(`institutions${_query}`, config);
      setinstitutions(_institutions);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar as instituições.");
    } finally {
      setisLoadingInstitutions(false);
    }
  };

  const [states, setstates] = useState([]);
  const [courses, setcourses] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);
        const { data: _states } = await api.get("state");
        setstates(
          [{ value: null, label: "-- Todos --" }].concat(
            _states.map(__state => ({
              value: __state.id,
              label: __state.name,
              uf: __state.uf,
            })),
          ),
        );
        const { data: _courses } = await api.get("courses", config);
        setcourses(
          _courses?.map(__course => ({
            value: __course?.id,
            label: __course?.title,
          })),
        );
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar a lista de cursos.");
      } finally {
        setisLoadingEssential(false);
        applyFilter(filter);
      }
    })();
  }, []);

  const [cities, setcities] = useState();
  useEffect(() => {
    if (filter?.state_id) {
      (async () => {
        try {
          setisLoadingCities(true);
          const { data: _cities } = await api.get(`cities/${filter.state_id}`);
          setcities(
            [{ value: null, label: "-- Todas --" }].concat(
              _cities.map(__city => ({
                value: __city.id,
                label: __city.name,
              })),
            ),
          );
        } catch (__error) {
          console.log("__error", __error);
          toast.error("Erro ao tentar carregar as cidades.");
        } finally {
          setisLoadingCities(false);
        }
      })();
    } else {
      setcities([]);
    }
  }, [filter?.state_id]);

  useEffect(() => {
    setbreadcrumb([{ label: "Instituições" }]);
  }, []);

  return (
    <Main>
      {!isLoadingEssential ? (
        <Content>
          <Row>
            <Col>
              <h2 className="mini-title">Instituições:</h2>
              <p className="small-label mb-3">
                Confira todas as instituições registradas, com informações essenciais e acesso a detalhes completos
                sobre cada uma.
              </p>
            </Col>
            {permissions?.institutions?.create && (
              <Col sm={3}>
                <div className="d-flex align-items-start justify-content-end h-100">
                  <ButtonLink color="primary" to="/institutions/new">
                    Cadastrar Instituição
                  </ButtonLink>
                </div>
              </Col>
            )}
          </Row>
          <Accordion2 id="page-filter">
            <Accordion2.Item eventKey={`page-filter`}>
              <Accordion2.Header>
                <span>Filtro</span>
                <Accordion2.Extras>
                  <span>{institutions?.total} resultados</span>
                </Accordion2.Extras>
              </Accordion2.Header>
              <Accordion2.Body>
                <Row>
                  <Col sm={3}>
                    <span>Nome</span>
                    <InputText
                      disabled={!!isWaitingResponse}
                      placeholder="..."
                      value={filter?.title}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          title: __ev.target.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Cursos</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={courses || []}
                      placeholder="..."
                      value={filter?.["courses.id"]}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          "courses.id": __ev.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Estado</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      options={states || []}
                      placeholder="..."
                      value={filter?.state_id}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          state_id: __ev.value,
                          city_id: null,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Cidade</span>
                    {!isLoadingCities ? (
                      <Slct
                        isDisabled={!!isWaitingResponse}
                        options={cities || []}
                        placeholder="..."
                        value={filter?.city_id}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            city_id: __ev.value,
                          });
                        }}
                      />
                    ) : (
                      <Loading small />
                    )}
                  </Col>
                </Row>
                {!isWaitingResponse && (
                  <Row className="mt-3">
                    <Col>
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          applyFilter();
                        }}
                      >
                        Aplicar Filtro
                      </Button>
                      <Button
                        color="grey"
                        size="sm"
                        onClick={() => {
                          applyFilter(filter_init);
                        }}
                      >
                        Limpar Filtro
                      </Button>
                    </Col>
                  </Row>
                )}
              </Accordion2.Body>
            </Accordion2.Item>
          </Accordion2>
          <Row className="mt-4">
            <Col>
              {!isLoadingInstitutions ? (
                <>
                  <TableResponsive
                    emptyMsg="Nenhuma formando encontrado."
                    table={{
                      head: [{ data: "ID" }, { data: "Instituição" }, { data: "Turmas" }, { data: "Localização" }],
                      body:
                        institutions?.data?.map(__institution => {
                          return {
                            link: `/institutions/edit/${__institution.id}`,
                            data: [
                              { element: __institution.id },
                              { element: `${__institution.title} - ${__institution.campus_name || "?"}` },
                              { element: __institution?.__meta__?.total_courses },
                              { element: `${__institution?.city?.name} - ${__institution?.states?.name}` },
                            ],
                          };
                        }) || [],
                    }}
                  />
                  <Pagenation
                    current={institutions?.page}
                    total={institutions?.lastPage}
                    pageChange={__page => {
                      applyFilter({
                        ...filter,
                        page: __page,
                      });
                    }}
                    className="mt-4"
                  />
                </>
              ) : (
                <Loading />
              )}
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
